
// ルーター
// History APIを利用してURLのナビゲーションを行います。
// path設定の一部を{~}で囲むとパスパラメータ扱いになります。
export const Router = new function() {
    /**
     * @typedef RouterPage
     * @property {string} key
     * @property {string} path
     */
    
    //--------------------
    //property

    /** 現在状態 
     * @type {RouterPage} */
    this.state = {
        key: "root"
    }

    /** 対象のページ設定
     * @type {RouterPage[]} */
    this.pages = [
        //key, path は必須
        { key:"root", path:"/" },
        { key:"not-found", path:"/404.html" },
    ]

    //--------------------
    //Method
    this.initialize = initialize
    this.navigate = navigate
    this.navigateByKey = navigateByKey
    this.getParameters = getParameters

    //--------------------
    //script
    var me = this

    window.onpopstate = function(){
        initialize()
    }

    /**
     * 初期化処理を行います。
     */
    function initialize(){
        var pg = getPage(window.location.pathname)
        if(pg != null){
            setState(pg)
        } else if(getPageByKey("not-found")){
            window.location.href = getPageByKey("not-found").path
        }
    }

    /**
     * パスを指定してURLを遷移します。
     * @param {string} path 移動先パス
     */
     function navigate(path){
        var url = new URL(path, location.href)
        var pg = getPage(url.pathname)
        if(pg==null){
            window.location.href = path
            return
        }
        if(location.href != url.href){
            setState(pg)
            window.history.pushState(null, "", path)
        }
    }

    /**
     * キーを指定してURLを遷移します。
     * @param {string} key 移動先ページのキー
     * @param {object} param パスパラメータ
     * @param {object} query クエリパラメータ 
     */
    function navigateByKey(key, params, query){
        var pg = getPageByKey(key)
        if(pg != null){
            let path = attachParameters(pg.path, params)
            if(query){
                path += "?" + Object.keys(query).map(k=>`${k}=${query[k]}`).join("&")
            }
            if(location.href != new URL(path, location.href).href){
                setState(pg)
                window.history.pushState(null, "", path)
            }
        }
    }

    /**
     * キーからページを取得します。
     * @param {string} key 
     * @returns {RouterPage}
     */
    function getPageByKey(key){
        for(let i=0; i<me.pages.length; i++){
            if(me.pages[i].key == key)
                return me.pages[i]
        }
        return null
    }

    /**
     * パスからページを取得します。
     * @param {string} path 
     * @returns {RouterPage}
     */
    function getPage(path){
        for(let i=0; i<me.pages.length; i++){
            if(comparePath(me.pages[i].path, path))
                return me.pages[i]
        }
        return null
    }

    /**
     * 文字列とパスの一致を判定します。
     * @param {string} path パス
     * @param {string} target 判定文字列
     * @returns {boolean}
     */
    function comparePath(path, target){
        return matchParamters(path, target) != null
    }
    
    /**
     * 現在のロケーションに含まれるパスパラメータを取得します。
     * @returns {Object.<string, string>}
     */
    function getParameters(){
        return matchParamters(me.state.path, window.location.pathname)
    }

    /**
     * パスと文字列を指定してパスパラメータを取得します。
     * パスが一致していない場合はnullが返ります。
     * @param {string} path 
     * @param {string} target
     * @returns {Object.<string, string>}
     */
    function matchParamters(path, target){
        let paths = path.split("/")
        let targets = target.split(/\/#?/)
        if(paths.length != targets.length) return null

        let ret = {}
        for(let i=0; i<paths.length; i++){
            let p = paths[i]
            let t = targets[i]
            
            if(/^\{.+\}$/.test(p)){
                ret[p.substring(1, p.length-1)] = t
            } else if(p != t){
                return null
            }
        }
        return ret
    }

    /**
     * パスパラメータに値を展開します。
     * @param {string} path 
     * @param {Object.<string, any>} params
     * @returns {string}
     */
    function attachParameters(path, params){
        if(!params) return path
        
        let paths = path.split("/")
        for(let i=0; i<paths.length; i++){
            let mc = /^\{(.+)\}$/.exec(paths[i])
            if(mc != null){
                paths[i] = `${params[mc[1]]}`
            }
        }
        return paths.join("/")
    }

    function setState(page){
        Object.keys(page).forEach(x => {
            me.state[x] = page[x]
        })
    }
}

// window.Router = Router